var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 29.3334H10C9.45333 29.3334 9 28.88 9 28.3334C9 27.7867 9.45333 27.3334 10 27.3334H23.3333C23.88 27.3334 24.3333 27.7867 24.3333 28.3334C24.3333 28.88 23.88 29.3334 23.3333 29.3334Z",
    fill: "#78C257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8 7.35997L22.4667 11.1733C21.76 11.68 20.7467 11.3733 20.44 10.56L17.92 3.83997C17.4933 2.67997 15.8533 2.67997 15.4267 3.83997L12.8933 10.5466C12.5867 11.3733 11.5867 11.68 10.88 11.16L5.54667 7.34664C4.48001 6.59997 3.06667 7.6533 3.50667 8.8933L9.05334 24.4266C9.24001 24.96 9.74667 25.3066 10.3067 25.3066H23.0133C23.5733 25.3066 24.08 24.9466 24.2667 24.4266L29.8133 8.8933C30.2667 7.6533 28.8533 6.59997 27.8 7.35997ZM20 19.6666H13.3333C12.7867 19.6666 12.3333 19.2133 12.3333 18.6666C12.3333 18.12 12.7867 17.6666 13.3333 17.6666H20C20.5467 17.6666 21 18.12 21 18.6666C21 19.2133 20.5467 19.6666 20 19.6666Z",
    fill: "#78C257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasy);
export default __webpack_public_path__ + "static/media/easy.a2dab2bc923e3aabfb53c645e5c698b1.svg";
export { ForwardRef as ReactComponent };